import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import styled from 'styled-components';

const IconDiv = styled.div`
  display: inline-block;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
`;

const PopupStyle = {
  borderRadius: 5,
  opacity: 0.7,
  padding: '7px',
};

interface Props extends MessageSourceProps {
  icons: Array<any>
}

const BillIcons = (props: Props) => {
  const {getMessage, icons} = props;
  return (
      icons.map(({iconName, iconSize, popUpText, color, ...other}: any, index: number) => {
        return (
            <Popup
                key={index}
                popperModifiers={{ preventOverflow: { boundariesElement: "window" } }}
                trigger={
                  <IconDiv>
                    <Icon name={iconName}
                          size={iconSize}
                          style={{color: color}}
                    />
                  </IconDiv>
                }
                pinned
                content={getMessage(popUpText)}
                size='small'
                position='top center'
                style={PopupStyle}
                inverted
            />
        );
      })
  );
};


export default withMessages(BillIcons);

